// extracted by mini-css-extract-plugin
export default {"CourseAbout":"CourseAbout_CourseAbout__oYBuR","FrontendCard":"CourseAbout_FrontendCard__H9eB3","Text":"CourseAbout_Text__+Waoq"};